const initialState = {
    user: null,
    notifications: [],
    notificationsCount: 0,
    skills: [],
    courses: []
}


const RootReducer = (state = initialState, action) => {
    //console.log(state, action);
    switch (action.type) {
        case "ADD_SKILL":
            return {
                ...state,
                skills: [...state.skills, action.skill]
            }
        case "ADD_USER":
            return {
                ...state,
                user: action.user
            }
        case "ADD_NOTIFICATIONS":
            return {
                ...state,
                notifications: action.notifications
            }
        case "ADD_NOTIFICATIONS_COUNT":
            return {
                ...state,
                notificationsCount: action.notificationsCount
            }
        case "ADD_COURSES":
            let list = [];
            for (let i = 0; i < action.courses.length; i++) {
                list.push({
                    id: action.courses[i].id,
                    name: action.courses[i].attributes.localizedMetadata[0].name
                })
            }
            return {
                ...state,
                courses: list
            }
        default:
            return state
    }
}

export default RootReducer;